/*
    创建者：shuxiaokai
    创建时间：2020-05-11 16:03
    模块名称：抽检批次数量组件
    备注：xxxx
*/
<template>

    <s-drag-move :id="id">
        <s-icon-card class="s-sample-num-widget" :style="wrapStyle">
            <img slot="head" :src="require('@/assets/imgs/excel.png')" width="100%" height="100%" @mousedown.stop.prevent="" />
            <div slot="title">{{ widgetSelfConfig.title }}</div>
            <div slot="subtitle">{{ widgetSelfConfig.count }}</div>
        </s-icon-card>
        <div slot="contextmenu">
            <context-item label="删除" shortcut="delete" @click="handleDeleteWidget"></context-item>
        </div>
    </s-drag-move>    
</template>

<script>
import contextItem from "@/pages/model/f/components/context-item"
export default {
    components: {
        "context-item": contextItem,
    },
    props: {
        id: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            offsetLeft: 0, //鼠标按下位置
            offsetTop: 0, //鼠标按下位置
        };
    },
    computed: {
        currentWidget() {
            return this.$store.state.widget.widgetList.find(val => val.id === this.id);
        },
        widgetSelfConfig: {
            get() {
                return this.currentWidget.config;
            },
        },
        wrapStyle() {
            const wrapStyle = {
                left: this.currentWidget.boundingClientRect.clientLeft + "px",
                top: this.currentWidget.boundingClientRect.clientTop + "px",
                width: this.currentWidget.boundingClientRect.width + "px",
                height: this.currentWidget.boundingClientRect.height + "px",
                backgroundColor: this.currentWidget.backgroundColor,
            } 
            return wrapStyle
        },
        selectWidgetId() {
            return this.$store.state.widget.selectWidgetId;
        }
    },
    mounted() {
       
    },
    methods: {
        //=====================================获取远程数据==================================//
        //=====================================前后端交互====================================//

        //=====================================组件间交互====================================//  
        //删除组件
        handleDeleteWidget() {
            
        },
        //=====================================其他操作=====================================//

    }
};
</script>



<style lang="scss">
.s-sample-num-widget {
    user-select: none;
    position: absolute;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
}

</style>
